import React, { useContext } from 'react'
import { DContext } from '../../context/Datacontext'

export const Test = () => {  
    const { options } = useContext(DContext)     
    console.log("options" , options)
  return (
    <div className='min-h-[85vh]'>Test</div>
  )
}
